import { Button } from "@headlessui/react";
import { GetCustomers } from "api/customer";
import { Customer } from "models/customer/customer";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { RoutePath } from "routes/route-path";

interface CustomerSelectorProps {
  onCustomerSelect: (customer: Customer) => void;
  defaultCustomer?: Customer;
}

const VehicleSearchComponent: React.FC<CustomerSelectorProps> = ({ onCustomerSelect, defaultCustomer }) => {
  const navigate = useNavigate();
  const [searchOption, setSearchOption] = useState("VEHICLE");
  const [searchText, setSearchText] = useState("");
  const [suggestions, setSuggestions] = useState<Customer[]>([]);

  // Sample existing customers for autocomplete
  const [existingCustomers, setExistingCustomers] = useState<Customer[]>([]);
  const [selectedCustomer, setSelectedCustomer] = useState<Customer>();
  useEffect(() => {
    loadCustomers();
    if (defaultCustomer) {
      setSearchOption("CUSTOMER");
    } else {
      setSearchOption("VEHICLE");
    }
  }, []);

  useEffect(() => {
    setSelectedCustomer(defaultCustomer);
  }, [defaultCustomer]);

  const loadCustomers = async () => {
    const res = await GetCustomers(undefined, undefined, 10000, 1);
    if (!(res?.status?.isError ?? false) && res?.data) {
      setExistingCustomers(res?.data);
      /*  if (selectedVehicle && selectedVehicle.currentOwner) {
        setSelectedCustomer(res?.data.find((c) => c.id == selectedVehicle.currentOwner!.id));
      } */
    } else {
      setExistingCustomers([]);
    }
  };

  const handleInputChange = (e: any) => {
    const value = e.target.value;
    setSearchText(value);

    // Filter suggestions based on the input
    if (value) {
      const filteredSuggestions =
        searchOption == "CUSTOMER"
          ? existingCustomers.filter((cus) => {
              return (cus.name ?? "").toLowerCase().includes(value.toLowerCase());
            })
          : existingCustomers.filter((cus) => {
              const _vehicles = cus.vehicles ?? [];
              const _matched = _vehicles.filter(
                (v) =>
                  (v.vehicleNo ?? "").toLowerCase().includes(value.toLowerCase()) ||
                  (v.chassisNo ?? "").toLowerCase().includes(value.toLowerCase())
              );
              return (_matched ?? []).length > 0;
            });

      setSuggestions(filteredSuggestions);
    } else {
      setSuggestions([]);
    }
  };

  const handleSuggestionClick = (suggestion: Customer) => {
    setSelectedCustomer(suggestion);
    setSuggestions([]); // Clear suggestions after selection
    onCustomerSelect(suggestion);
    setSearchText("");
  };

  return (
    <div className="bg-gray-50 rounded-lg border-2 border-gray-200 p-4">
      <div className="grid grid-cols-1 gap-4 mb-5 lg:grid-cols-2 xl:grid-cols-12 ">
        {!defaultCustomer && (
          <>
            <div className="mb-4 xl:col-span-12 bg-color">
              <label className="inline-block mb-2 text-base font-medium">Search by</label>
              <div className="flex items-center">
                <label className="mr-4">
                  <input
                    type="radio"
                    name="ownerType"
                    value="VEHICLE"
                    checked={searchOption === "VEHICLE"}
                    onChange={() => {
                      setSearchOption("VEHICLE");
                    }}
                  />
                  <span className="px-2">Vehicle Details</span>
                </label>
                <label>
                  <input
                    type="radio"
                    name="ownerType"
                    value="CUSTOMER"
                    checked={searchOption === "CUSTOMER"}
                    onChange={() => setSearchOption("CUSTOMER")}
                  />
                  <span className="px-2">Customer Details</span>
                </label>
                <div className="ml-10">
                  <Button
                    type="button"
                    className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                    onClick={() => navigate(`${RoutePath.Admin_Vehicles}?opt=n`)}
                  >
                    New Vehicle
                  </Button>
                </div>
              </div>
            </div>

            <div className="xl:col-span-10">
              <div className="relative">
                <input
                  type="text"
                  className="ltr:pl-8 rtl:pr-8 search form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                  placeholder={
                    searchOption == "CUSTOMER" ? "Search by Customer Name Email Phone" : "Search by Vehicle Number"
                  }
                  autoComplete="off"
                  value={searchText}
                  onChange={handleInputChange}
                />

                {/*   <Search className="inline-block size-4 absolute ltr:left-2.5 rtl:right-2.5 top-2.5 text-slate-500 dark:text-zink-200 fill-slate-100 dark:fill-zink-600" /> */}
                {/* Suggestions dropdown */}
                {suggestions.length > 0 && (
                  <div className="absolute z-10 mt-1 bg-white border border-gray-300 rounded shadow-lg">
                    {suggestions.map((suggestion, index) => (
                      <div
                        key={index}
                        className="px-4 py-2 cursor-pointer hover:bg-gray-100"
                        onClick={() => handleSuggestionClick(suggestion)}
                      >
                        {(suggestion.vehicles ?? []).length > 0
                          ? (suggestion.name ?? "") +
                            "    (" +
                            (suggestion.vehicles![suggestion.vehicles!.length - 1].vehicleNo ?? "") +
                            ")"
                          : suggestion.name ?? ""}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
            <div className="xl:col-span-2"></div>
          </>
        )}
        <div className="xl:col-span-6">
          {selectedCustomer && (
            <div className="mt-2">
              <p>
                <strong>Name:</strong> {selectedCustomer.name ?? ""}
              </p>
              <p>
                <strong>Contact No:</strong> {selectedCustomer.contactNumber ?? ""}
              </p>
              <p>
                <strong>Email:</strong> {selectedCustomer.email ?? ""}
              </p>
              {/*  {(selectedCustomer.vehicles ?? []).length > 0 && (
                <p>
                  <strong>Vehicle No:</strong>{" "}
                  {selectedCustomer.vehicles![selectedCustomer.vehicles!.length - 1].vehicleNo ?? ""}
                </p>
              )} */}
            </div>
          )}
        </div>
        <div className="xl:col-span-6">
          {selectedCustomer && (selectedCustomer.vehicles ?? []).length > 0 && (
            <div className="mt-2">
              <p>
                <strong>Vehicle No:</strong>{" "}
                {selectedCustomer.vehicles![selectedCustomer.vehicles!.length - 1]?.vehicleNo ?? ""}
              </p>
              <p>
                <strong>Chassis No:</strong>{" "}
                {selectedCustomer.vehicles![selectedCustomer.vehicles!.length - 1]?.chassisNo ?? ""}
              </p>
              <p>
                <strong>Year:</strong> {selectedCustomer.vehicles![selectedCustomer.vehicles!.length - 1]?.year ?? ""}
              </p>
            </div>
          )}
        </div>

        {/*    <div className="xl:col-span-2">
        <div className="ltr:lg:text-right rtl:lg:text-left">
          <Link
            to=""
            onClick={onSearchClick}
            type="button"
            className="text-white btn min-w-40 bg-custom-800 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
          >
            <span className="align-middle">Search</span>
          </Link>
        </div>
      </div> */}
      </div>
    </div>
  );
};

export default VehicleSearchComponent;
